import { useEffect } from "react";
import grapesjs from "grapesjs";
import grapesJsWebpage from "grapesjs-preset-webpage";
import grapesJsBasic from 'grapesjs-blocks-basic';

export default function Grapes() {
    useEffect(() => {
        // grapesjs.init({
        //     container: "#gjs",
        //     height: "700px",
        //     width: "100%",
        //     plugins: [grapesJsWebpage],
        //     pluginsOpts: {
        //         grapesJsWebpage: {
        //             blocksBasicOpts: {
        //                 blocks: [
        //                     "column1",
        //                     "column2",
        //                     "column3",
        //                     "column3-7",
        //                     "text",
        //                     "link",
        //                     "image",
        //                     "video",
        //                 ],
        //                 flexGrid: 1,
        //             },
        //             blocks: ["link-block", "quote", "text-basic",],
        //         },
        //     },
        // });
        grapesjs.init({
            container: '#gjs',
            height: '700px',
            width: '100%',
            plugins: [grapesJsWebpage, grapesJsBasic],
            storageManager: {
                id: 'gjs-',
                type: 'local',
                autosave: true,
                storeComponents: true,
                storeStyles: true,
                storeHtml: true,
                storeCss: true,
            },
            deviceManager: {
                devices:
                    [
                        {
                            id: 'desktop',
                            name: 'Desktop',
                            width: '',
                        },
                        {
                            id: 'tablet',
                            name: 'Tablet',
                            width: '768px',
                            widthMedia: '992px',
                        },
                        {
                            id: 'mobilePortrait',
                            name: 'Mobile portrait',
                            width: '320px',
                            widthMedia: '575px',
                        },
                    ]
            },
            pluginsOpts: {
                grapesJsBasic: {
                    blocksBasicOpts: {
                        blocks: ['column1', 'column2', 'column3', 'column3-7', 'text', 'link', 'image', 'video'],
                        flexGrid: 1,
                    },
                    blocks: ['link-block', 'quote', 'text-basic', 'column1', 'column2', 'column3', 'column3-7', 'text', 'link', 'image', 'video'],
                },
            }
        })
    }, [])
    return (
        <div>
            <div id="gjs"></div>
            <div id="blocks"></div>
        </div>
    );
}
